export default function custom() {
  return false;
}

custom.message = function message(value, options = {}) {
  return options.message || 'precisa ser válido';
};
